<template>
  <div class="px-4 pb-2 bg-white rounded-lg h-100">
    <DataTable />
  </div>
</template>

<script>
import DataTable from "@/own/components/fulfillment/orders/DataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "Orders",
  components: { DataTable },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
